/**
 * 리프레시 토큰으로 재시도 가능한 에러 코드
 */
export const REFRESHABLE_ERROR_CODES = [
  'AUTH-00004', // EXPIRED_ACCESS_TOKEN
  'AUTH-00006', // ACCESS_TOKEN_NOT_FOUND
] as const;

/**
 * 리프레시 불가능한 에러 코드 (즉시 로그아웃)
 */
export const LOGIN_REQUIRED_ERROR_CODES = [
  'AUTH-00010', // 인증 정보에 해당하는 사용자가 존재하지 않음
  'AUTH-00002', // INVALID_ACCESS_TOKEN
  'AUTH-00001', // UNAUTHORIZED
  'AUTH-00003', // INVALID_REFRESH_TOKEN
  'AUTH-00005', // EXPIRED_REFRESH_TOKEN
  'AUTH-00008', // TOKEN_REFRESHED
  'AUTH-00007', // REFRESH_TOKEN_NOT_FOUND
  'AUTH-00011', // COOKIE_NOT_FOUND
  'AUTH-00014', // INVALID_TOKEN_STATE
] as const;

export type RefreshableErrorCode = (typeof REFRESHABLE_ERROR_CODES)[number];
export type LoginRequiredErrorCode = (typeof LOGIN_REQUIRED_ERROR_CODES)[number];
